/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useCallback, useEffect, useContext, useState } from 'react';
import { Config, EditableComponent, MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { PageParamsContext } from '../../modules/context/PageContext';

import { LocalServicesProps } from './LocalServices.types';
import { useServiceStore, serviceStore } from '../../modules/store/serviceStore';

import { LocalServicesMenu } from './LocalServicesMenu/LocalServicesMenu';
import { LocalServicesCards } from './LocalServicesCards/LocalServicesCards';
import { statesConstant } from '../../modules/utils/constants';
import { LocalServicesCardsProps } from './LocalServicesCards';
import { LocalServicesData } from './data/LocalServicesData';

const { NEXT_PUBLIC_AEM_SITE } = process.env;

export const LocalServices: FC<LocalServicesProps> = pageProps => {
  const { preProcessorResponse } = useContext(PageParamsContext);
  const { state = '' } = preProcessorResponse || {};
  const setServiceData = useServiceStore((state: serviceStore) => state.setservice);
  const [loading, setLoading] = useState<boolean>(true);
  const [localServicesData, setLocalServicesData] = useState<any>(null);

  useEffect(() => {
    if (
      state?.toLowerCase() === statesConstant.connected &&
      sessionStorage.getItem('amenityClicked') &&
      !sessionStorage.getItem('reloadConnectedUrl')
    ) {
      setServiceData(
        {
          serviceClicked: true,
        },
        false,
        false,
        {}
      );
    }
  }, []);

  const onLocalServicesDataFetched = useCallback((data: any) => {
    setLoading(false);
    setLocalServicesData({ ...data });
  }, []);

  return (
    <>
      {!localServicesData ? (
        <LocalServicesData
          isAuthorMode={pageProps?.isAuthorMode ?? false}
          onLocalServicesDataFetched={onLocalServicesDataFetched}
        />
      ) : null}

      {(state === statesConstant.connect || state === statesConstant.preconnect) &&
      !loading &&
      localServicesData &&
      localServicesData?.property ? (
        <LocalServicesMenu data-component-name="o-ppv5-LocalServices" {...pageProps} {...localServicesData} />
      ) : null}
      <LocalServicesCards
        data-component-name="o-ppv5-LocalServices"
        {...(pageProps as LocalServicesCardsProps)}
        loading={loading}
        {...localServicesData}
      />
    </>
  );
};

export const LocalServicesConfig = {
  emptyLabel: 'services_carousel',
  isEmpty: (_props: MappedComponentProperties) => false,
  resourceType: `${NEXT_PUBLIC_AEM_SITE}/components/content/services-carousel`,
} as Config<MappedComponentProperties>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LocalServicesEditable = (props: any) => (
  <EditableComponent config={LocalServicesConfig} {...props}>
    <LocalServices {...props} />
  </EditableComponent>
);
